import { ORDER_TYPE } from '../../dto/enum';

export const getOrderType = orderType => {
  let type = 'orders_view.header.pickup';
  if (orderType === ORDER_TYPE.DELIVERY) type = 'orders_view.header.delivery';
  if (orderType === ORDER_TYPE.IN_COMMERCE)
    type = 'orders_view.header.in_commerce';
  return type;
};
